import * as React from 'react';
import {Button} from '../../button';
import {Drawer, DrawerContent, DrawerDescription, DrawerTitle} from '../../drawer';
import {AirbnbSelectMobileWheel} from './SelectMobileWheel';
import {type SelectValue} from './types';
import {type SelectOption} from '../../lib/selector-option';
import type {ReactNode} from 'react';

type AirbnbSelectMobileContentProps<
  T,
  V extends SelectValue,
  L extends string | number | ReactNode,
> = {
  open: boolean;
  onOpenChange: (nextOpen: boolean) => void;
  onClose: () => void;
  listboxId: string;
  labelId: string;
  label: string;
  mobileTitle?: string;
  doneLabel: string;
  errorId?: string;
  options: SelectOption<T, V, L>[];
  disabled?: boolean;
  menuClassName?: string;
  scrollTop: number;
  activeIndex: number;
  listRef: React.RefObject<HTMLDivElement>;
  onScroll: () => void;
  onOptionClick: (option: SelectOption<T, V, L>) => void;
  onKeyDown: React.KeyboardEventHandler<HTMLDivElement>;
  onDone: () => void;
  getOptionId: (index: number) => string;
  noOptionsMessage?: () => string | undefined;
};

function AirbnbSelectMobileContent<
  T,
  V extends SelectValue,
  L extends string | number | ReactNode,
>({
  open,
  onOpenChange,
  onClose,
  listboxId,
  labelId,
  label,
  mobileTitle,
  doneLabel,
  errorId,
  options,
  disabled,
  menuClassName,
  scrollTop,
  activeIndex,
  listRef,
  onScroll,
  onOptionClick,
  onKeyDown,
  onDone,
  getOptionId,
  noOptionsMessage,
}: AirbnbSelectMobileContentProps<T, V, L>) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent onClose={onClose} lockScroll={false}>
        <DrawerTitle className="sr-only">{mobileTitle ?? label}</DrawerTitle>
        <DrawerDescription className="sr-only">{label}</DrawerDescription>
        <div className="px-6 pb-4 pt-1">
          <AirbnbSelectMobileWheel
            id={listboxId}
            options={options}
            labelledBy={labelId}
            describedBy={errorId}
            disabled={disabled}
            menuClassName={menuClassName}
            scrollTop={scrollTop}
            activeIndex={activeIndex}
            listRef={listRef}
            onScroll={onScroll}
            onOptionClick={onOptionClick}
            onKeyDown={onKeyDown}
            getOptionId={getOptionId}
            noOptionsMessage={noOptionsMessage}
          />
          <Button type="button" onClick={onDone} className="mt-4 h-12 mb-8 w-full">
            {doneLabel}
          </Button>
        </div>
      </DrawerContent>
    </Drawer>
  );
}

export {AirbnbSelectMobileContent};
